export default __webpack_public_path__ + "static/media/common_kingfisher.a50b38cb.jpg";